import { collection, findSelector, member, resource } from "data/helpers/apiv3";
import { Follow } from "data/records";
import { fulfilled } from "lib/promiseMiddlewareHelpers";

const [api, actions] = resource(Follow, [
  ["list", collection.get("", ["userId", "extras"])],
  ["create", collection.post("", ["itemType", "itemId", "level"])],
  ["update", member.patch("", ["follow"])],
]);

const selectors = {
  ...findSelector(Follow),
  followsForUser: (state, userId, excludeBlocks = true) =>
    state.apiv3.follow.id.filter((f) => f.userId === userId && maybeExcludeBlocks(f.level, excludeBlocks)),
  byUserAndItem: (state, uid, iid, type, excludeBlocks = true) =>
    state.apiv3.follow.id.find(
      ({ userId, itemId, itemType, level }) =>
        uid === userId && iid === itemId && type === itemType && maybeExcludeBlocks(level, excludeBlocks)
    ),
  byItem: (state, iid, type, excludeBlocks = true) =>
    state.apiv3.follow.id.filter(
      ({ itemId, itemType, level }) => iid === itemId && type === itemType && maybeExcludeBlocks(level, excludeBlocks)
    ),
};

const blocking = (level) => ["block", "spam", "harassment"].includes(level);
const maybeExcludeBlocks = (level, excludeBlocks) => (excludeBlocks ? !blocking(level) : true);

const removeFromState = (s, follow) => {
  let nextState = s;
  const { userId, itemId, itemType } = follow;
  if (itemType === "User") {
    const peer = s.id.find((f) => f.userId === itemId && f.itemId === userId);
    nextState = s.set("id", s.id.delete(peer?.id));
  } else {
    console.warn("NOT IMPLEMENTED: follows with itemType !== 'User'");
  }
  return nextState;
};

const maybeRemovePeerFollow = (s, follow) => {
  let nextState = s;
  if (blocking(follow.level)) {
    // remove the blocked user's follow from state as well (the backend does
    // this itself, but doesn't notify us of the additional deletion)
    nextState = removeFromState(nextState, follow);
  }
  return nextState;
};

const reducers = {
  [fulfilled(actions.create.type)]: (state, action) => {
    const { follow } = action.payload;
    const nextState = maybeRemovePeerFollow(state, follow);
    return nextState;
  },
  [fulfilled(actions.update.type)]: (state, action) => {
    const { follow } = action.payload;
    const nextState = maybeRemovePeerFollow(state, follow);
    return nextState;
  },
};

const initialState = {};

export {
  api as followApi,
  actions as followActions,
  selectors as followSelectors,
  reducers as followReducers,
  initialState as followInitialState,
};
